import { store } from "@betacrew/jars-flux";

export const componentKey = "MEMBER_USER_HISTORY";

const initialState = {
    payersList: [{ label: 'Select Payer', value: 0 }],
    taxYearsList: [{ label: 'Select Tax Year', value: 0 }],
    formList: [{ label: 'Select Form', value: 0 }],
    selectedForm: { label: 'Select Form', value: 0 },
    selectedTaxYear: { label: 'Select Tax Year', value: 0 },
    selectedPayer: { label: 'Select Payer', value: 0 },
    loadingState: false,
    memberUserHistory: [],
    totalMemberUserHistory: 0,
    rowsPerPage: 10,
    skip: 0,
    exportFile: false
}

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setPayerList: (state, action) => {
            state.payersList = action.payload
        },
        setTaxYearList: (state, action) => {
            state.taxYearsList = action.payload;
        },
        setFormList: (state, action) => {
            state.formList = action.payload;
        },
        setSelectedPayer: (state, action) => {
            state.selectedPayer = action.payload;
        },
        setSelectedTaxYear: (state, action) => {
            state.selectedTaxYear = action.payload;
        },
        setSelectedForm: (state, action) => {
            state.selectedForm = action.payload;
        },
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
        setMemberUserHistory: (state, action) => {
            state.memberUserHistory = action.payload
        },
        setTotalHistory: (state, action) => {
            state.totalMemberUserHistory = action.payload;
        },
        setRowsPerPage: (state, action) => {
            state.rowsPerPage = action.payload;
        },
        setSkip: (state, action) => {
            state.skip = action.payload;
        },
        setExportFile: (state, action) => {
            state.exportFile = action.payload;
        },
    },
    initialReducerState: initialState
});

export const { setPayerList, setTaxYearList, setFormList, setSelectedTaxYear, setSelectedPayer, setSelectedForm, setLoadingState, setMemberUserHistory, setTotalHistory, setRowsPerPage, setSkip, setExportFile } = actions